import React from 'react';
import Icon from '../../../components/AppIcon';

const ContactInfo = ({ language }) => {
  const content = {
    en: {
      title: 'Contact Information',
      subtitle: 'Reach out to us through any of these channels',
      office: 'Head Office',
      officeAddress: 'Deqing County\nZhejiang, China',
      phone: 'Phone',
      phoneNumber: '+8619706820472',
      email: 'Email',
      emailAddress: 'info@africcoffee.com',
      salesEmail: 'sales@africcoffee.com',
      hours: 'Business Hours',
      hoursDetail: 'Monday - Friday: 9:00 AM - 6:00 PM (CST)\nSaturday: 10:00 AM - 4:00 PM\nSunday: Closed',
      response: 'Response Time',
      responseDetail: 'We typically respond to inquiries within 24 hours during business days',
      social: 'Connect With Us',
      wechat: 'WeChat',
      wechatId: 'AfricoffeeWGIH',
      linkedin: 'LinkedIn',
      linkedinHandle: 'WGIH-Africoffee'
    },
    zh: {
      title: '联系信息',
      subtitle: '通过以下任何渠道与我们联系',
      office: '总部',
      officeAddress: '中国浙江省德清县',
      phone: '电话',
      phoneNumber: '+8619706820472',
      email: '电子邮件',
      emailAddress: 'info@africcoffee.com',
      salesEmail: 'sales@africcoffee.com',
      hours: '营业时间',
      hoursDetail: '周一至周五：上午9:00 - 下午6:00（中国标准时间）\n周六：上午10:00 - 下午4:00\n周日：休息',
      response: '响应时间',
      responseDetail: '我们通常在工作日24小时内回复咨询',
      social: '与我们联系',
      wechat: '微信',
      wechatId: 'AfricoffeeWGIH',
      linkedin: '领英',
      linkedinHandle: 'WGIH-Africoffee'
    }
  };

  const t = content?.[language];

  const contactItems = [
    {
      icon: 'MapPin',
      title: t?.office,
      content: t?.officeAddress,
      action: null
    },
    {
      icon: 'Phone',
      title: t?.phone,
      content: t?.phoneNumber,
      action: `tel:${t?.phoneNumber?.replace(/\s/g, '')}`
    },
    {
      icon: 'Mail',
      title: t?.email,
      content: `${t?.emailAddress}\n${t?.salesEmail}`,
      action: `mailto:${t?.emailAddress}`
    },
    {
      icon: 'Clock',
      title: t?.hours,
      content: t?.hoursDetail,
      action: null
    }
  ];

  const socialLinks = [
    {
      icon: 'MessageCircle',
      name: t?.wechat,
      handle: t?.wechatId,
      color: 'var(--color-success)'
    },
    {
      icon: 'Linkedin',
      name: t?.linkedin,
      handle: t?.linkedinHandle,
      color: '#0A66C2'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="bg-card rounded-lg border border-border p-6">
        <h2 className="text-2xl font-heading font-semibold text-foreground mb-2">
          {t?.title}
        </h2>
        <p className="text-muted-foreground mb-6">
          {t?.subtitle}
        </p>

        <div className="space-y-5">
          {contactItems?.map((item, index) => (
            <div key={index} className="flex gap-4">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon name={item?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1">
                <h3 className="text-sm font-medium text-foreground mb-1">
                  {item?.title}
                </h3>
                {item?.action ? (
                  <a
                    href={item?.action}
                    className="text-sm text-primary hover:underline whitespace-pre-line"
                  >
                    {item?.content}
                  </a>
                ) : (
                  <p className="text-sm text-muted-foreground whitespace-pre-line">
                    {item?.content}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="flex items-center gap-2 mb-4">
          <Icon name="Info" size={20} color="var(--color-primary)" />
          <h3 className="text-lg font-heading font-semibold text-foreground">
            {t?.response}
          </h3>
        </div>
        <p className="text-sm text-muted-foreground">
          {t?.responseDetail}
        </p>
      </div>
      <div className="bg-card rounded-lg border border-border p-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
          {t?.social}
        </h3>
        <div className="space-y-3">
          {socialLinks?.map((social, index) => (
            <div key={index} className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg hover:bg-muted transition-smooth">
              <Icon name={social?.icon} size={20} color={social?.color} />
              <div>
                <p className="text-sm font-medium text-foreground">{social?.name}</p>
                <p className="text-xs text-muted-foreground">{social?.handle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;